import React from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import FormWrapper from '../../../../components/forms/FormWrapper';
import { InputField } from '../../../../components/forms/fields';
import { CreateSupplierFormValues, SupplierFormProps } from './types';
import { supplierValidationSchema } from './validation';

const defaultValues: CreateSupplierFormValues = {
    legalName: '',
    district: '',
    headquarters: '',
    postalCode: '',
    tin: '',
    companyIdentificationNumber: '',
};

const SupplierForm = ({ onSubmit, submitText, initialValues, isDialogView }: SupplierFormProps) => {
    const { t } = useTranslation();
    return (
        <Formik onSubmit={onSubmit} validationSchema={supplierValidationSchema} initialValues={{ ...defaultValues, ...initialValues }}>
            {formikProps => (
                <FormWrapper isSubmitting={formikProps.isSubmitting} isDialogView={isDialogView} submitText={submitText} disabled>
                    <InputField
                        name='legalName'
                        required
                        formikProps={formikProps}
                        label={t('Legal name')}
                    />
                    <InputField
                        name='district'
                        formikProps={formikProps}
                        label={t('District')}
                    />
                    <InputField
                        name='headquarters'
                        formikProps={formikProps}
                        label={t('Address')}
                    />
                    <InputField
                        name='postalCode'
                        formikProps={formikProps}
                        label={t('Postal code')}
                    />
                    <InputField
                        name='tin'
                        formikProps={formikProps}
                        label={t('Tax Identification Number')}
                    />
                    <InputField
                        name='companyIdentificationNumber'
                        formikProps={formikProps}
                        label={t('Company Identification Number')}
                    />
                </FormWrapper>
            )}
        </Formik>
    );
};

export default SupplierForm;
